<template>
    <div email-log-container>
        <!--<div>Notification History</div>-->

        <DxDataGrid
            ref="gridRef"
            :data-source="gridData"            
        >
          <DxColumn
              data-field="SentOn"
              caption="Date Sent"
              data-type="text"
          />
          <DxColumn
              data-field="UsersNotified"
              caption="Users Notified"
              data-type="text"              
          />
        </DxDataGrid>
    </div>
</template>

<script>
    import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';

    export default {
        components: {
            DxDataGrid, DxColumn,
        },
        data(){
            return{
                gridData: null,
            }
        },
        created(){
            //Get the accountId that is stored globally
            //var accountId = this.$store.state.data.currentAccountId;
            var accountId = localStorage.dinesafeAccountId;

            /*
                Hit the web service, get a list log of how many e-mails were sent out each day
                Stored proc = pr_admin_EmailSentReport
            */
            this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetNotificationLog',
            {
                AccountId: accountId,
            }
            ).then(function(data){         
                if(data.body != null && data.body!= '')
                {
                    var responseData = JSON.parse(data.body);        

                    //this.$store.commit("setLocationData", responseData["Locations"]);

                    this.gridData = responseData;
                }
            });
        },
    }
</script>